/**
 * ContradictionCallout component
 *
 * Displays when user's perception contradicts the actual AI status
 */

import { AlertTriangle, Sparkles, Lightbulb } from 'lucide-react';

interface ContradictionCalloutProps {
  type: 'false_positive_ai' | 'false_negative_ai' | 'partial_surprise';
  message: string;
}

const icons = {
  false_positive_ai: AlertTriangle,
  false_negative_ai: Sparkles,
  partial_surprise: Lightbulb,
};

const styles = {
  false_positive_ai: 'bg-yellow-50 border-yellow-200 text-yellow-800 dark:bg-yellow-900/20 dark:border-yellow-800 dark:text-yellow-200',
  false_negative_ai: 'bg-purple-50 border-purple-200 text-purple-800 dark:bg-purple-900/20 dark:border-purple-800 dark:text-purple-200',
  partial_surprise: 'bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-200',
};

export function ContradictionCallout({ type, message }: ContradictionCalloutProps) {
  const Icon = icons[type];

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border p-4 ${styles[type]}`}
      role="alert"
    >
      <Icon className="mt-0.5 h-5 w-5 flex-shrink-0" aria-hidden="true" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
}
